import React, { useMemo, useState } from "react";
import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import { useEffect } from "react";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import { pageSizeType, sortByType } from "../../redux/slice/events/events-search-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
import LoadingComp from "../../components/re-usable/loading/loading";
import { retrieveTypeFilters } from "../../redux/slice/events/type-filters-slice";
import { retrieveEventSearch } from "../../redux/slice/events/events-search-slice";
import GetSocialMedia from "../../components/re-usable/get-social-media";
import { Link, useLocation, Location, useNavigate } from "react-router-dom";
import { Collapse, Nav } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import LoadHomeGoogleAds from "../../components/advertisement/load-home-google-ads";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";

type FilterValues = {
  urlPageSize: number;
  urlSortBy: number;
  urlTitle: string;
  urlLocation: string;
  urlLocationName: string;
  urlEtype: string;
  urlFromDate: string;
  urlToDate: string;
  urlPastEvents: boolean
  urlPageNumber: number
};

const formatDate = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, "0")
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const year = date.getFullYear().toString();
  return year + month + day
}


const NewsList = (): JSX.Element => {
  const location: Location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const pageSizes = [12, 24, 48];
  const defaultPageSize = pageSizes.find(x => Number(queryParams.get('pgSize')) === x) || 12;
  const defaultIsPastEvents = queryParams.get('ShowOnlyPast') && queryParams.get('ShowOnlyPast') === "1" ? true : false;
  const defaultPageNumber = queryParams.get('pagenumber') ? Number(queryParams.get('pagenumber')) : queryParams.get('page') ? Number(queryParams.get('page')) : 1;
  const defaultEventName = queryParams.get('title') || '';
  const defaultLocationName = queryParams.get('locationName') || '';//queryParams.get('LocationInput') || ''
  const fromEventsSponsorship = queryParams.get('sponsorship') || '';

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const navigator = useNavigate();
  const dispatch = useAppDispatch();
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setsortBy] = useState<number>(1);
  const [pageNumber, setPageNumber] = useState<number>(defaultPageNumber);
  const [eventType, setEventType] = useState<string>(queryParams.get('etype') || '');
  const [locationInput, setLocationInput] = useState<string>(defaultLocationName);
  const [isLocationInput, setIsLocationInput] = useState<boolean>(false);
  const [eventName, setEventName] = useState<string>(defaultEventName);
  const [isEventName, setIsEventName] = useState<boolean>(false);
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");
  const [isShowFilterDate, setIsShowFilterDate] = useState<boolean>(false);
  const [isPastEvents, setIsPastEvents] = useState<boolean>(defaultIsPastEvents);
  const [isShowFilter, setIsShowFilter] = useState<boolean>(true);
  const [isInitialPageLoad, setIsInitialPageLoad] = useState(true);
  const [activeTab, setActiveTab] = useState('events');

  const { EventsSearchData, EventsSearchLoading } = useSelector((state: RootState) => state.EventsSearch);
  const { TypeFiltersData } = useSelector((state: RootState) => state.TypeFilters);
  const { RapsEuropeData: pageData } = useSelector((state: RootState) => state.rapsEurope);

  const defaultFilterValues = {
    urlPageSize: defaultPageSize,
    urlSortBy: Number(queryParams.get('sortBy')) || 1,
    urlTitle: defaultEventName,
    urlLocation: queryParams.get('location') || '',
    urlLocationName: queryParams.get('locationName') || '',
    urlEtype: queryParams.get('etype') || '',
    urlFromDate: queryParams.get('fromDate') || '',
    urlToDate: queryParams.get('toDate') || '',
    urlPastEvents: defaultIsPastEvents,
    urlPageNumber: defaultPageNumber,
  };

  let EventSearch = {
    showOnlyPast: isPastEvents,
    eventType: eventType,
    locationInput: locationInput,
    eventName: eventName,
    sortBy: sortBy,
    pageSize: pageSize,
    pageNumber: pageNumber,
    fromDate: fromDate,
    toDate: toDate
  };

  useEffect(() => {
    dispatch(retrievePageMenu("%2FEducation%2FEvents"));
  }, [])

  useEffect(() => {
    dispatch(retrieveTypeFilters());
    dispatch(retrieveEventSearch(EventSearch));
  }, [dispatch]);

  useEffect(() => {
    let dfv = defaultFilterValues;

    if (dfv.urlPageSize !== pageSize) setPageSize(dfv.urlPageSize as pageSizeType);
    if (dfv.urlSortBy !== sortBy) setsortBy(dfv.urlSortBy);
    if (dfv.urlTitle !== eventName) {
      setEventName(dfv.urlTitle);
    }
    if (dfv.urlLocationName !== locationInput) setLocationInput(dfv.urlLocationName);
    if (dfv.urlEtype !== eventType) {
      setEventType(dfv.urlEtype);
    }
    if (dfv.urlFromDate !== fromDate) {
      setFromDate(dfv.urlFromDate);
      setStartDate(null);
    }
    if (dfv.urlToDate !== toDate) {
      setToDate(dfv.urlToDate);
      setEndDate(null);
    }
    if (dfv.urlPastEvents !== isPastEvents) setIsPastEvents(!isPastEvents);
    if (dfv.urlPageNumber !== pageNumber) setPageNumber(dfv.urlPageNumber);
  }, [location]);

  const [filterValues, setFilterValues] = useState<FilterValues>(defaultFilterValues)

  const updateUrl = (
    urlSortBy?: number,
    urlPageSize?: number,
    urlTitle?: string,
    urlLocation?: string,
    urlLocationName?: string,
    urlEtype?: string,
    urlFromDate?: string,
    urlToDate?: string,
    urlPastEvents?: string,
    urlPageNumber?: string
  ) => {
    const urlSearchParams = new URLSearchParams();
    urlSortBy && urlSearchParams.append("sortBy", urlSortBy.toString());
    urlPageSize && urlSearchParams.append("pgSize", urlPageSize.toString());
    urlTitle && urlSearchParams.append("title", urlTitle);
    urlLocation && urlSearchParams.append("location", urlLocation);
    urlLocationName && urlSearchParams.append("locationName", urlLocationName);
    urlEtype && urlSearchParams.append("etype", urlEtype);
    urlFromDate && urlSearchParams.append("fromDate", urlFromDate);
    urlToDate && urlSearchParams.append("toDate", urlToDate);
    urlPastEvents && urlSearchParams.append("ShowOnlyPast", urlPastEvents);
    urlPageNumber && urlSearchParams.append("page", urlPageNumber.toString());

    navigator(`/events?${urlSearchParams.toString()}`);
  };

  useEffect(() => {
    switch (eventType) {
      case "meetings__chapterevents":
        setActiveTab("chapters")
        break;
      case "meetings__partnerevents":
        setActiveTab("partners")
        break;
      default:
        setActiveTab("events")
        break;
    }
  }, [eventType])

  useEffect(() => {
    if (!isInitialPageLoad) {
      updateUrl(
        filterValues.urlSortBy,
        filterValues.urlPageSize,
        filterValues.urlTitle,
        filterValues.urlLocation,
        filterValues.urlLocationName,
        filterValues.urlEtype,
        filterValues.urlFromDate,
        filterValues.urlToDate,
        filterValues.urlPastEvents ? "1" : undefined,
        filterValues.urlPageNumber ? filterValues.urlPageNumber.toString() : undefined,
      )
    } else {
      setIsInitialPageLoad(false);
    }
  }, [filterValues])

  const handlePageChange = (urlPageNumber: number) => {

    setPageNumber(urlPageNumber);
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlPageNumber }))
  };

  const handlePageSize = (value: pageSizeType) => {
    let urlPageSize = value;
    let urlPageNumber = 1;

    setPageSize(urlPageSize);
    setPageNumber(urlPageNumber);

    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlPageSize, urlPageNumber }))
  };

  const handleSortBy = (value: sortByType) => {
    setsortBy(value);
    const urlSortBy = value;
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlSortBy }))
  };

  // Keyword
  const handleEventType = (value: string) => {
    switch (eventType) {
      case "meetings__chapterevents":
        setActiveTab("chapters")
        break;
      case "meetings__partnerevents":
        setActiveTab("partners")
        break;
      default:
        setActiveTab("events")
        break;
    }
    setEventType(value);
    setPageNumber(1)
    const urlEtype = value;
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlEtype }))
  };

  // Remove the Keyword filter
  const removeEventType = () => {
    setEventType('');
    const urlEtype = '';
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlEtype }))
  };

  // On change Location
  const handleLocation = (value: string) => {
    if (value) {
      setLocationInput(value);
      setPageNumber(1)
      setIsLocationInput(true)
      const urlLocationName = value;
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlLocationName }))
      if (!isInitialPageLoad) {
        dispatch(retrieveEventSearch(EventSearch));
      } else {
        setIsInitialPageLoad(false);
      }
    } else {
      EventSearch = {
        showOnlyPast: isPastEvents,
        eventType: eventType,
        locationInput: '',
        eventName: eventName,
        sortBy: sortBy,
        pageSize: pageSize,
        pageNumber: pageNumber,
        fromDate: fromDate,
        toDate: toDate
      };
      dispatch(retrieveEventSearch(EventSearch));
      const urlLocationName = '';
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlLocationName }))
    }

  };

  // Remove the Location filter
  const removeLocation = () => {
    setLocationInput('');
    const urlLocationName = '';
    setIsLocationInput(false)
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlLocationName }))
    EventSearch = {
      showOnlyPast: isPastEvents,
      eventType: eventType,
      locationInput: '',
      eventName: eventName,
      sortBy: sortBy,
      pageSize: pageSize,
      pageNumber: pageNumber,
      fromDate: fromDate,
      toDate: toDate
    };

    dispatch(retrieveEventSearch(EventSearch));

  };


  // On change Location
  const handleEventName = (value: string) => {
    if (value.trim() !== '') {
      setEventName(value);
      setPageNumber(1)
      setIsEventName(true)
      const urlTitle = value;
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlTitle }))
      if (!isInitialPageLoad) {
        dispatch(retrieveEventSearch(EventSearch));
      } else {
        setIsInitialPageLoad(false);
      }
    } else {
      EventSearch = {
        showOnlyPast: isPastEvents,
        eventType: eventType,
        locationInput: locationInput,
        eventName: '',
        sortBy: sortBy,
        pageSize: pageSize,
        pageNumber: pageNumber,
        fromDate: fromDate,
        toDate: toDate
      };
      dispatch(retrieveEventSearch(EventSearch));
      const urlTitle = '';
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlTitle }))
    }

  };

  // Remove the Location filter
  const removeEventName = () => {
    setEventName('');
    const urlTitle = '';
    setIsEventName(false)
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlTitle }))
    EventSearch = {
      showOnlyPast: isPastEvents,
      eventType: eventType,
      locationInput: locationInput,
      eventName: '',
      sortBy: sortBy,
      pageSize: pageSize,
      pageNumber: pageNumber,
      fromDate: fromDate,
      toDate: toDate
    };

    dispatch(retrieveEventSearch(EventSearch));

  };


  // On Change From Date
  const handleStartDate = (date: Date) => {
    if (date) {

      let curFromDate = new Date(date);
      let getFromDate = curFromDate.toLocaleDateString();
      setFromDate(getFromDate);
      setPageNumber(1)
      const urlFromDate = getFromDate;
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlFromDate }))
    }
  };

  // On Change End Date
  const handleEndDate = (date: Date) => {
    if (date) {
      let curToDate = new Date(date);
      let getToDate = curToDate.toLocaleDateString();
      setToDate(getToDate);
      setPageNumber(1)
      const urlToDate = getToDate;
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlToDate }))
    }
  };

  // Remove the Keyword filter
  const removeFromDateItem = () => {
    setFromDate("");
    setStartDate(null)
    const urlFromDate = '';
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlFromDate }))
  };

  const removeToDateItem = () => {
    setToDate("");
    setEndDate(null)
    const urlToDate = '';
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlToDate }));
  }

  const totalRecords = EventsSearchData[0]?.totalSearchResults;
  const totalPages = Math.ceil(totalRecords / pageSize);

  useEffect(() => {
    if (!isInitialPageLoad) {
      dispatch(retrieveEventSearch(EventSearch));
    } else {
      setIsInitialPageLoad(false);
    }
  }, [pageNumber, sortBy, pageSize, eventType, eventName, locationInput, fromDate, toDate, isPastEvents]);

  // On click Search
  const handleSearch = () => {
    if (eventName.trim() !== '') {
      setPageNumber(1)
      setIsEventName(true)
      const urlTitle = eventName;
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlTitle }))
      if (!isInitialPageLoad) {
        dispatch(retrieveEventSearch(EventSearch));
      } else {
        setIsInitialPageLoad(false);
      }
    }

    if (locationInput.trim() !== '') {
      setPageNumber(1)
      setIsLocationInput(true)
      const urlLocationName = locationInput;
      setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlLocationName }))
      if (!isInitialPageLoad) {
        dispatch(retrieveEventSearch(EventSearch));
      } else {
        setIsInitialPageLoad(false);
      }
    }
    if (eventType || locationInput.trim() !== '' || isLocationInput || isEventName || eventName.trim() !== '' || fromDate.trim() !== '' || toDate.trim() !== '') {
      dispatch(retrieveEventSearch(EventSearch));
      // setIsShowFilterDate(true);
    }
  };

  const clearBtn = (isPastEvents: boolean) => {
    clearSort(isPastEvents, true);

  };

  const clearSort = (isPastEvents: boolean, fromClear: boolean) => {
    setEventType('')
    setLocationInput('')
    setFromDate('')
    setToDate('')
    setEventName('')
    setIsShowFilterDate(false)
    setStartDate(null);
    setEndDate(null)
    setPageNumber(1)
    setPageSize(12)
    setsortBy(1)

    setIsEventName(false)
    setIsLocationInput(false)

    const urlPageSize = 12;
    const urlSortBy = 1;
    const urlTitle = '';
    const urlLocation = '';
    const urlLocationName = '';
    const urlEtype = '';
    const urlFromDate = '';
    const urlToDate = '';
    const urlPastEvents = fromClear ? isPastEvents : !isPastEvents;
    const urlPageNumber = 1

    setFilterValues(() => ({
      urlPageSize, urlSortBy,
      urlTitle, urlLocation,
      urlLocationName, urlEtype,
      urlFromDate, urlToDate,
      urlPastEvents, urlPageNumber
    }))

    EventSearch = {
      showOnlyPast: urlPastEvents,
      eventType: urlEtype,
      locationInput: urlLocation || urlLocationName,
      eventName: '',
      sortBy: urlSortBy,
      pageSize: urlPageSize,
      pageNumber: urlPageNumber,
      fromDate: urlFromDate,
      toDate: urlToDate
    };

    dispatch(retrieveEventSearch(EventSearch));

  };

  // Past Event
  const pastEvent = (isPastEvents: boolean) => {
    clearSort(isPastEvents, false)
    setActiveTab("events");
    setIsPastEvents(!isPastEvents)
    setPageSize(12)
    setsortBy(1)
    setPageNumber(1)

    const urlPastEvents = !isPastEvents;
    const urlSortBy = 0, urlPageSize = 0, urlTitle = '', urlLocation = '', urlLocationName = '', urlEtype = '', urlFromDate = '', urlToDate = '', urlPageNumber = 1;

    setFilterValues(() => ({
      urlSortBy, urlPageSize, urlTitle, urlLocation, urlLocationName, urlEtype, urlFromDate, urlToDate, urlPastEvents, urlPageNumber
    }));
  }

  // Handle Upcoming Events Tab
  const handleTabFilter = (tabName: string) => {
    setActiveTab(tabName)
    switch (tabName) {
      case "chapters":
        handleEventType("meetings__chapterevents");
        break;
      case "partners":
        handleEventType("meetings__partnerevents");
        break;
      default:
        handleEventType("");
        break;
    }
    setPageSize(12)
    setsortBy(1)
    setPageNumber(1)
    const urlSortBy = 0, urlPageSize = 0, urlTitle = '', urlLocation = '', urlLocationName = '', urlFromDate = '', urlToDate = '', urlPageNumber = 1;
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues, urlSortBy, urlPageSize, urlTitle, urlLocation, urlLocationName, urlFromDate, urlToDate, urlPageNumber
    }));
  }

  // const handleNarrowResults
  const handleNarrowResults = () => {
    setIsShowFilter(!isShowFilter)
  }
  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);

  // Handle Start today date
  const handleStartTodayDate = () => {
    let curFromDate = new Date();
    let getFromDate = curFromDate.toLocaleDateString();
    setStartDate(curFromDate);
    setPageNumber(1)
    const urlFromDate = formatDate(curFromDate);
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlFromDate }))
  }

  // Handle End today date
  const handleEndTodayDate = () => {
    let curToDate = new Date();
    let getToDate = curToDate.toLocaleDateString();
    setEndDate(curToDate);
    setPageNumber(1)
    const urlToDate = formatDate(curToDate);
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlToDate }))
  }

  const cachedLoadGoogleAds = useMemo(() => <LoadHomeGoogleAds />, []);

  if (!(pageData[0]?.result)) return <LoadingComp />;

  return (
    <>
      <Helmet>
        <title>{EventsSearchData[0]?.menuItemName}</title>
      </Helmet>
      <EventListingStyles />
      <div className="container">
        <div className="page-tools row">
          <div className="col-sm-8 col-lg-9">
            <div className="message"><b>{fromEventsSponsorship === "calendar" ? "Thank you for your interest in sponsoring RAPS Events. Please browse the calendar to discover more upcoming events." : ""}</b></div>
            <div className="breadcrumb">
            </div>
          </div>
          <div className="col-sm-4 col-lg-3">
            <GetSocialMedia />
          </div>
        </div>
      </div>
      <div className="container two-column-alt">
        {/* <hr />
                <h1>News Article More</h1>
                <hr /> */}
        <div className="row">
          <div className="col-lg-3">
            <div className="filter filter-rail fitler-event-search event-sec">
              <header className="filter-header">
                <h3>Narrow Results</h3>
                <button
                  id="data-toggle-4"
                  type="button"
                  className="filter-toggle"
                  data-toggle=""
                  data-target="toggledContent_EventFilterRail"
                  data-init=""
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => handleNarrowResults()}
                >
                  {
                    isShowFilter ? '-' : '+'
                  }
                </button>
              </header>
              <Collapse in={isShowFilter}>
                <div
                  id="toggledContent_EventFilterRail"
                  className={`form-container ${isShowFilter ? 'active' : ''}`}
                  aria-labelledby="data-toggle-4"
                >
                  <input
                    type="hidden"
                    name="p$lt$ctl04$SiteMainPlaceholder$p$lt$ctl03$NewsSmartSearchFilter$hdnDocumentTag"
                    id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_NewsSmartSearchFilter_hdnDocumentTag"
                  />
                  {isShowFilterDate || eventType || (isLocationInput && locationInput.trim() !== '') || (isEventName && eventName.trim() !== '') || fromDate || toDate ? (
                    <div id="sort-details" className="current-facets">
                      <p className="facet-heading">You've Selected</p>

                      <ul className="list-unstyled list-facet-active">
                        {
                          (fromDate) ? (
                            <li className="">
                              <span
                                id="close-from-date"
                                className="facet-clear"
                                onClick={() => removeFromDateItem()}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </span>
                              From Date
                              <ul className="list-inline list-facet-items">
                                <li>
                                  <button
                                    disabled={true}
                                    className="btn btn-default btn-sm"
                                  >
                                    {fromDate}
                                  </button>
                                </li>
                              </ul>
                            </li>
                          ) : null
                        }

                        {
                          (toDate) ? (
                            <li className="">
                              <span
                                id="close-from-date"
                                className="facet-clear"
                                onClick={() => removeToDateItem()}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </span>
                              To Date
                              <ul className="list-inline list-facet-items">
                                <li>
                                  <button
                                    disabled={true}
                                    className="btn btn-default btn-sm"
                                  >
                                    {toDate}
                                  </button>
                                </li>
                              </ul>
                            </li>
                          ) : null
                        }

                        {
                          (eventType) ? (
                            <li className="">
                              <span
                                id="close-category"
                                className="facet-clear"
                                onClick={() => removeEventType()}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </span>
                              Event Type
                              <ul className="list-inline list-facet-items">
                                <li>
                                  {TypeFiltersData[0]?.filterItems?.map(
                                    (item, index) => {
                                      return item.value === eventType ? (
                                        <button
                                          key={index}
                                          disabled={true}
                                          type="button"
                                          className="btn btn-default btn-sm"
                                        >
                                          {item.textDisplay}{" "}
                                        </button>
                                      ) : null;
                                    }
                                  )}
                                </li>
                              </ul>
                            </li>
                          ) : null
                        }

                        {
                          ((locationInput.trim() !== '')) ? ( //isLocationInput && 
                            <li className="">
                              <span
                                id="close-category"
                                className="facet-clear"
                                onClick={() => removeLocation()}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </span>
                              Location
                              <ul className="list-inline list-facet-items">
                                <li>
                                  <button
                                    disabled={true}
                                    type="button"
                                    className="btn btn-default btn-sm"
                                  >
                                    {locationInput}
                                  </button>
                                </li>
                              </ul>
                            </li>
                          ) : null
                        }

                        {
                          (isEventName && eventName.trim() !== '') ? (
                            <li className="">
                              <span
                                id="close-category"
                                className="facet-clear"
                                onClick={() => removeEventName()}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </span>
                              Event Name
                              <ul className="list-inline list-facet-items">
                                <li>
                                  <button
                                    disabled={true}
                                    type="button"
                                    className="btn btn-default btn-sm"
                                  >
                                    {eventName}
                                  </button>

                                </li>
                              </ul>
                            </li>
                          ) : null
                        }



                      </ul>

                      <div className="text-right">
                        <span id="clear-sort" className="facet-clear-all" onClick={() => clearBtn(isPastEvents)}>
                          Clear All
                        </span>
                      </div>
                    </div>
                  ) : null}

                  <form
                    onSubmit={(event) => {
                      event.preventDefault();
                      handleSearch();
                    }}
                  >
                    <fieldset>

                      <div className="form-group">
                        <div className="input-group-sm">
                          <label htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_NewsSmartSearchFilter_dtFromDate" id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_NewsSmartSearchFilter_lblFromDate" className="EditingFormLabel">From Date</label>

                          <DatePicker
                            selected={startDate}
                            onChange={(date: React.SetStateAction<Date | null>) => { date && setStartDate(date); handleStartDate(date as Date) }}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            placeholderText="Select Date"
                            dropdownMode="select"
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            todayButton="Today"
                          >
                          </DatePicker>


                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group-sm">
                          <label htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_NewsSmartSearchFilter_dtToDate" id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_NewsSmartSearchFilter_lblToDate" className="EditingFormLabel">To Date</label>


                          <DatePicker
                            selected={endDate}
                            onChange={(date: React.SetStateAction<Date | null>) => { date && setEndDate(date); handleEndDate(date as Date) }}

                            selectsEnd
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            placeholderText="Select Date"
                            dropdownMode="select"
                            startDate={startDate}
                            endDate={endDate}
                            minDate={isPastEvents ? null : startDate}
                            maxDate={isPastEvents ? startDate : null}
                            todayButton="Today"
                          >
                          </DatePicker>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group-sm">
                          <label
                            htmlFor="type"
                            className="EditingFormLabel"
                          >
                            Type
                          </label>
                          <select
                            name="type"
                            id="type"
                            className="form-control"
                            value={eventType}
                            onChange={(e) =>
                              handleEventType(e.target.value)
                            }
                          >
                            <option value="">Select Categories</option>
                            {TypeFiltersData &&
                              TypeFiltersData[0]?.filterItems?.map(
                                (item, index) => {
                                  return (
                                    <option key={index} value={item.value}>
                                      {item.textDisplay}
                                    </option>
                                  );
                                }
                              )}
                          </select>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group-sm">
                          <label
                            htmlFor="location"
                            id="location-label"
                            className="EditingFormLabel"
                          >
                            Location
                          </label>
                          <input
                            name="location"
                            type="text"
                            id="location"
                            value={locationInput}
                            placeholder="Enter a location"
                            className="form-control"
                            onChange={(e) => {
                              setLocationInput(e.target.value);
                              if ((e.target.value).trim() === '') {
                                setIsLocationInput(false)
                                let urlLocationName = '';
                                setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlLocationName }))
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group-sm">
                          <label
                            htmlFor="event-name"
                            id="event-name-label"
                            className="EditingFormLabel"
                          >
                            Event Name
                          </label>
                          <input
                            name="event-name"
                            type="text"
                            id="event-name"
                            value={eventName}
                            placeholder=""
                            className="form-control"
                            onChange={(e) => {
                              setEventName(e.target.value);
                              if ((e.target.value).trim() === '') {
                                setIsEventName(false)
                                let urlTitle = '';
                                setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlTitle }))
                              }
                            }
                            }
                          />
                        </div>
                      </div>


                      <div className="form-group">
                        <div id="pnlButtons" className="row g-3">
                          <div className="col-md-6">
                            <input
                              type="submit"
                              name="search"
                              value="Filter"
                              id="btnSearch"
                              onClick={() => { handleSearch(); }}
                              className="btn btn-default btn-block btn-responsive"
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="reset"
                              name="reset"
                              value="Clear"
                              id="btnReset"
                              className="btn btn-secondary btn-block btn-responsive"
                              onClick={() => clearBtn(isPastEvents)}
                            />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </Collapse>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="title-wrapper">
              <h1>
                {
                  isPastEvents ? 'Past Events' : 'Upcoming Events'
                }
              </h1>
              <a className="more link" onClick={() => { pastEvent(isPastEvents); }}>
                <span >
                  {
                    isPastEvents ? 'VIEW UPCOMING EVENTS' : 'PAST EVENTS'
                  }
                </span>
              </a>
            </div>
            {!isPastEvents ?
              <Nav className="d-flex nav-tabs flex-wrap" activeKey={activeTab} defaultActiveKey="events" style={{ marginBottom: '1px' }}>
                <Nav.Item >
                  <Nav.Link id="eventsTab" eventKey="events" onClick={(e) => handleTabFilter("events")}>
                    <span className="material-icons-outlined">event_available</span> <span className="searchtag" style={{ verticalAlign: 'top' }}> RAPS Events</span>
                  </Nav.Link>
                </Nav.Item >
                <Nav.Item >
                  <Nav.Link id="chaptersTab" eventKey="chapters" onClick={(e) => handleTabFilter("chapters")}>
                    <span className="material-icons-outlined">groups</span> <span className="searchtag" style={{ verticalAlign: 'top' }}> Chapter/LNG Events</span>
                  </Nav.Link>
                </Nav.Item >
                <Nav.Item >
                  <Nav.Link id="partnersTab" eventKey="partners" onClick={(e) => handleTabFilter("partners")}>
                    <span className="material-icons-outlined">handshake</span> <span className="searchtag" style={{ verticalAlign: 'top' }}> Partner Events</span>
                  </Nav.Link>
                </Nav.Item >
              </Nav> : ""}
            <div className="module listing news-articles-list">
              {totalRecords === 0 ? (
                <div className="no-result">
                  <span>No results were found.</span>
                </div>
              ) : null}

              <div className="sort-status">
                {totalRecords !== 0 ? (
                  <>
                    <div className="sort-results">
                      <label>
                        Results{" "}
                        <strong>
                          {((pageNumber * pageSize) - pageSize) + 1}-{((pageSize * pageNumber) > totalRecords) ? totalRecords : (pageSize * pageNumber)}
                        </strong>{" "}
                        of <strong> {totalRecords}</strong>
                      </label>
                    </div>
                    <div className="sort-count">
                      <div className="form-inline">
                        <div className="input-group-sm">
                          <label
                            className="form-label"
                            htmlFor="sortShowCount"
                          >
                            Show
                          </label>
                          {/* onChange={(e) => handlePageSize(e.target.value)} */}
                          <select
                            id="pageSize"
                            className="form-control"
                            value={pageSize}
                            onChange={(e) =>
                              handlePageSize(
                                Number(e.target.value) as pageSizeType
                              )
                            }
                          >
                            <option value="12">12 per page</option>
                            <option value="24">24 per page</option>
                            <option value="48">48 per page</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="sort-by">
                      <div className="form-inline">
                        <div className="input-group-sm">
                          <label
                            className="form-label"
                            htmlFor="sortShowCount"
                          >
                            Sort By
                          </label>
                          <select
                            id="sortShowCount"
                            className="form-control"
                            value={sortBy}
                            onChange={(e) =>
                              handleSortBy(Number(e.target.value) as sortByType)
                            }
                          >
                            <option value="1">Date</option>
                            <option value="2">Title</option>
                            <option value="3">RAC</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="sort-paging">
                      {
                        totalPages > 1 && (
                          <Pagination
                            className="pagination pagination-sm"
                            {...bootstrap5PaginationPreset} // include Bootstrap 5 preset
                            total={totalPages}
                            current={pageNumber}
                            onPageChange={(page: number) =>
                              handlePageChange(page)
                            }
                          />
                        )

                      }

                    </div>
                  </>
                ) : null}
              </div>
              <ul id="LstEvents" className="item-list">
                <div className="events module listing">
                  {EventsSearchLoading ? (
                    <LoadingComp />
                  ) : (
                    EventsSearchData &&
                    EventsSearchData[0]?.eventItemsList?.map(
                      (item, index) => {
                        return (<li className="item" key={index}>
                          <div className="item-content">
                            <div className="badge badge-featured hide">Featured Event</div>
                            <div className="item-category">
                              <span className="category-type category-raps-event">
                                <span className="category-text ">
                                  {

                                    item.badge && item.badge?.map((badge, ind) => {

                                      return ((item.badge.length - 1) > ind) ? (
                                        <React.Fragment key={ind}>
                                          <span dangerouslySetInnerHTML={{ __html: badge }}></span>,
                                        </React.Fragment>
                                      ) : (
                                        <span key={ind} dangerouslySetInnerHTML={{ __html: badge }}></span>
                                      )
                                    })
                                  }
                                </span>
                              </span>
                            </div>
                            <h3 className="title">
                              <Link to={`/events/${item.nodeName}`}>{item.eventName}</Link>
                            </h3>
                            <ul className="meta">
                              <li className="meta-item date">
                                {item.formattedDate}
                              </li>

                              <li className="meta-item timezone">
                                {item.useLocation ? item.f2fLocation : item.timeZone}
                              </li>


                            </ul>
                            <div className="meta" style={{ paddingRight: '10px' }} dangerouslySetInnerHTML={{ __html: item.shortDescription }}>

                            </div>
                          </div>
                          <div className="item-content">
                            {
                              (item.racCredits > 0) ? (
                                <div className="rac-credits">
                                  <span className="badge badge-credits">{item.racCredits}</span>
                                  <span className="badge-label">RAC Credits</span>
                                </div>
                              ) : null

                            }
                            {
                              isPastEvents ?
                                (
                                  <><Link to={`/events/${item.nodeName}`} className="btn btn-responsive btn-primary">LEARN MORE</Link><br /></>
                                ) :
                                (
                                  !item.isComingSoon ?
                                    (
                                      item.fromImpexium ?
                                        (
                                          <><Link to={`/events/${item.nodeName}`} className="btn btn-responsive btn-primary">LEARN MORE</Link>
                                            <a href={item.registrationUrl} target="_blank" className="btn btn-responsive btn-default" rel="noopener noreferrer">ADD TO CART</a></>
                                        ) :
                                        item.isPreview ?
                                          (
                                            <><Link to={`/events/${item.nodeName}`} className="btn btn-responsive btn-primary">LEARN MORE</Link></>
                                          ) :
                                          (
                                            <><Link to={`/events/${item.nodeName}`} className="btn btn-responsive btn-primary">LEARN MORE</Link>
                                              <a href={item.registrationUrl} target="_blank" className="btn btn-responsive btn-default" rel="noopener noreferrer">REGISTER</a></>
                                          )
                                    ) : null
                                )

                            }
                          </div>
                        </li>

                        );
                      }
                    )
                  )}

                </div>
              </ul>
              {
                totalPages > 1 && (
                  <div className="sort-status-bottom">
                    <div className="sort-paging">

                      <Pagination
                        className="pagination pagination-sm"
                        {...bootstrap5PaginationPreset} // include Bootstrap 5 preset
                        total={totalPages}
                        current={pageNumber}
                        onPageChange={(page: number) => handlePageChange(page)}
                      />


                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <div className="container my-4">
        {cachedGoogleAds}
        {cachedLoadGoogleAds}
      </div>
    </>
  );
};

const EventListingStyles = () => {
  return (
    <>
      <style>
        {`
          .nav-tabs > .nav-item > .nav-link.active { 
            background-color: #EDF0F0;
            border-color: #828385 #828385 #fff;
            font-weight: bold;
          }
          .nav-tabs > .nav-item > .nav-link:not(.active) {
            border-color: #dee2e6 #dee2e6 #fff;
          }
          .nav-tabs > .nav-item > .nav-link:not(.active):hover  {
             font-weight: bold;
          }
          .nav-tabs {
            border-bottom: none;
          }
        `}
      </style>
    </>
  )
};

export default NewsList;
